import isEmpty from 'lodash/isEmpty'
import React from 'react'

import { ExtendingRow } from '@ztechapps/webui.data-tools'
import { CellWithContextMenu } from '@ztechapps/webui.menu'

import {
  TaskTemplateStatusActionEditor,
  StatusActionsBadge,
} from '../FromTemplate/TaskTemplateValueInput/TaskTemplateStatusActionEditor'
import type { TemplateStatusAction } from '../FromTemplate/TaskTemplateValueInput/TaskTemplateStatusActionEditor'

import { DeleteTaskButton } from './DeleteTaskButton'
import { useContext } from './Context'

export const ListRow = (props) => {
  const { name, statusActions, _config } = props
  const index = _config?.index
  const { newTasks, setNewTasks } = useContext()
  const handleStatusActionsChange = (updatedActions: TemplateStatusAction[]) => {
    const tasks = [...newTasks]
    tasks[index] = {
      ...tasks[index],
      statusActions: !isEmpty(updatedActions) ? updatedActions : undefined,
    }
    setNewTasks(tasks)
  }

  const extensionRow = (
    <TaskTemplateStatusActionEditor statusActions={statusActions} onChange={handleStatusActionsChange} />
  )

  return (
    <ExtendingRow {...props} extensionRow={extensionRow} colSpan={2}>
      <CellWithContextMenu className="p-2" contextMenuContent={<DeleteTaskButton index={index} />}>
        {name}
        <StatusActionsBadge count={statusActions?.length} className="ms-2" />
      </CellWithContextMenu>
    </ExtendingRow>
  )
}
